import {Component, OnDestroy, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router, NavigationStart} from '@angular/router';
import * as $ from 'jquery';
import {SearchResult} from './SearchResult';
import {Globals} from '../globals';
import {Location} from '@angular/common';

@Component({
  selector: 'app-search-resoult',
  templateUrl: './search-resoult.component.html',
  styleUrls: ['./search-resoult.component.scss']
})
export class SearchResoultComponent implements OnInit, OnDestroy {
  searchResult: SearchResult;
  hayZinvorXoragrer = [];
  zinujXoragrer = [];
  categoryIndex = 0;
  url;
  page: any;
  p: any = 1;
  p_news: any = 1;
  collection: any[] = [];
  collectionNews: any[] = [];
  curent;
  hay_zinvor = new Array();
  aspar = new Array();
  // aspar_tesanyut= new Array();
  // zinuj_tesanyut = new Array();
  // zinuj = new Array();
  // music = new Array();
  // video = new Array();
  // lrahos= new Array();
  // titles = new Array();
  // aspar_galery = new Array();
  query = localStorage.getItem('query');

  constructor(private http: HttpClient, public _location: Location, public router: Router, public globals: Globals, private route: ActivatedRoute, public sanitizer: DomSanitizer) {
    const url_string = location.href;
    this.url = url_string;

  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
          this.p_news = params.p_news ? params.p_news : 1;
          this.p = params.page ? params.page : 1;
        }
      );
    $(window).scrollTop(0);
    this.stopAllAudio();
    this.changeReq();

    this.changel();

  }

  ngOnDestroy() {
    // localStorage.removeItem('xoragir');
    // localStorage.removeItem('categ');
    // localStorage.removeItem('query');
  }


  changeReq(type = false) {
    // $(window).scrollTop(0);
    console.log($(window).scrollTop());
    this.http.get<SearchResult>(this.globals.urlMain + 'homes/search' + '?param=' + this.query, {
      params: {
        page: this.p,
        page_handes: this.p,
        page_news: this.p_news,
        category: localStorage.getItem('categ'),
        year: localStorage.getItem('year'),
        xoragir: localStorage.getItem('xoragir'),
      }
    }).subscribe(data => {
      this.searchResult = data;
      if (type) {
        $(window).scrollTop($(window).scrollTop() - 1400);
      } else {
        $(window).scrollTop(0);
      }
      // console.log(this.slider)
      const k = Number(data.data.handes.pagination.total);
      this.collection = [];
      for (let i = 0; i <= k; i++) {
        this.collection.push(i);
      }
      console.log('this.collection');
      console.log(this.collection);

      const kn = Number(data.data.news.pagination.total);
      this.collectionNews = [];
      for (let i = 0; i <= kn; i++) {
        this.collectionNews.push(i);
      }
      console.log('this.collectionNews');
      console.log(this.collectionNews);
    });


  }

  changel(type = false) {

    this.changeReq(type);
    this.router.navigate(['/home/searchResult'], {queryParams: {page: this.p, p_news: this.p_news}});
    // var height = $('header').height();
    // $(window).scrollTop(height);
    this.router.events
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate') {
          setTimeout(() => {
            location.reload();
          }, 200);
        }
      });
  }

  openZinujVideo(event) {
    var width = $(event).closest('.ziuzharchiveVideos').css('width');
    var height = $(event).closest('.ziuzharchiveVideos').css('height');
    var video = $(event).closest('.ziuzharchiveVideos').find('iframe').attr('src');
    $('iframe').each(function () {
      // alert('s')

      $(this).attr('src', $(this).attr('src'));

    });
    $('p.absolute').css({
      'position': 'absolute'
    });
    $('p.absolute').closest('.ziuzharchiveVideos').css({
      'width': width,
      'height': height
    });
    $(event).css({
      'position': 'relative'
    });

    $(event).closest('.ziuzharchiveVideos').css({
      'width': '100%',
      'height': '300px'
    });


  }

  stopAllAudio() {
    document.addEventListener('play', function (e) {
      var audios = document.getElementsByTagName('video');
      for (var i = 0, len = audios.length; i < len; i++) {
        if (audios[i] != e.target) {
          audios[i].pause();
        }
      }
    }, true);
  }

  openModal(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.iframe').find('.title').text();
    var iframe = $(target).closest('.iframe').find('img').attr('data-id');
    var newIframe = document.createElement('iframe');
    newIframe.src = iframe;
    newIframe.height = '100%';
    newIframe.width = '100%';
    newIframe.allowFullscreen = true;
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);
  }

  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }

  openModalaudio(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var audiosrc = $(target).closest('.itemContent').find('audio').attr('data-id');
    var newIframe = document.createElement('img');
    newIframe.src = iframe;
    newIframe.style.width = '100%';
    newIframe.style.objectFit = 'cover';
    // newIframe.allowFullscreen= true;
    // var audio = document.createElement('iframe');
    // audio.src= audiosrc;

    var oldaudio = document.createElement('audio');
    oldaudio.src = audiosrc;
    oldaudio.style.height = '30px';
    oldaudio.style.width = '92%';
    oldaudio.style.position = 'absolute';
    oldaudio.style.bottom = '30px';
    oldaudio.style.zIndex = '9';
    oldaudio.controls = true;
    // $(target).closest('.smallZinuj').remove();
    $('.modalDescription').html('').append(oldaudio);
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

    // height: 30px;
    // width: 92%;
    // position: absolute;
    // margin-top: 58%;

  }

}
